<div class="clerk-search-wrapper navbar-search">
  <div class="input-group navbar-search-input-group">
    <input
      type="text"
      class="form-control"
      [placeholder]="searchInputPlaceholder | translate"
      [(ngModel)]="searchInputValue"
      (ngModelChange)="onInputChange($event)"
      (focus)="onFocus()"
      (keydown.enter)="navigateToSearch()"
    />
    <button class="btn btn-outline-secondary" type="button" (click)="onIconButtonClick()">
      <i [class]="getInputIcon()"></i>
    </button>
  </div>

  <div class="navbar-search-results clerk-search-results" [hidden]="!showResults && !showNoResults">
    <ng-template #resultsHost></ng-template>
  </div>
</div>
